import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class SubscriptionListService {
  constructor(private http: HttpClient) {}
  // ton apis
  getSubscritionPlans(data) {
    return this.http.post(environment.apiUrl + "admin/subscription/all", data);
  }

  addSubscriptionPlan(data) {
    return this.http.post(environment.apiUrl + "admin/subscription/add", data);
  }

  updateSubscriptionPlan(id, data) {
    return this.http.put(
      environment.apiUrl + `admin/subscription/update/${id}`,
      data
    );
  }

  deletePlan(id) {
    return this.http.delete(
      environment.apiUrl + `admin/subscription/delete/${id}`
    );
  }
}
